/**
 * Represents the membership selection of the user.
 */
export enum MembershipSelectionType {
	NO_MEMBER_BASIS = 'NoMemberBasis', 						// user is currently no member and wants to become a basis member
	NO_MEMBER_PLUS = 'NoMemberPlus', 						// user is currently no member and wants to become a plus member
	NO_MEMBER_WITHOUT = 'NoMemberWithout', 					// user is currently no member and does not want to become a member
	MEMBER_BASIS = 'MemberBasis', 							// user is already a basis member
	MEMBER_PLUS = 'MemberPlus', 							// user is already a plus member
	MEMBER_WITHOUT_LOGIN_DATA = 'MemberWithoutLoginData',	// user is already a member but does not have the login data
	UNKNOWN = 'unknown'										// selection is unknown
}

export namespace MembershipSelectionType {
	/**
	 * Checks the possibility to be able to login by any given type.
	 * @param type any kind of possible parameter.
	 * @returns true, if the type is MemberBasis or MemberPlus.
	 */
	export function isLoginPossible(type: string): boolean {
		switch (type) {
			case MembershipSelectionType.MEMBER_BASIS:
			case MembershipSelectionType.MEMBER_PLUS:
				return true;
			default:
				return false;
		}
	}
	/**
	 * checks the correctness of a parameter to be an MembershipSelectionType
	 * @param type any kind of possible parameter.
	 * @returns true, when the parameter is a valid MembershipSelectionType
	 */
	export function isMembershipSelectionType(type: string): boolean {
		switch (type) {
			case MembershipSelectionType.NO_MEMBER_WITHOUT:
			case MembershipSelectionType.UNKNOWN:
			case MembershipSelectionType.MEMBER_BASIS:
			case MembershipSelectionType.MEMBER_PLUS:
			case MembershipSelectionType.NO_MEMBER_BASIS:
			case MembershipSelectionType.NO_MEMBER_PLUS:
			case MembershipSelectionType.MEMBER_WITHOUT_LOGIN_DATA:
				return true;
			default:
				return false;
		}
	}
	/**
	 * getMembershipCode value as used in backend API
	 */
	export function getMembershipCode(type: string): number {
		switch (type) {
			case MembershipSelectionType.NO_MEMBER_WITHOUT:
			case MembershipSelectionType.UNKNOWN:
				return 0;
			case MembershipSelectionType.MEMBER_BASIS:
			case MembershipSelectionType.NO_MEMBER_BASIS:
				return 1;
			case MembershipSelectionType.MEMBER_PLUS:
			case MembershipSelectionType.NO_MEMBER_PLUS:
				return 2;
			default:
				return 0;
		}
	}
	/**
	 * getMembershipType value as used in VES Calculator Model
	 */
	export function getMembershipType(isMember: boolean): string {
		switch (isMember) {
			case false:
				return MembershipSelectionType.NO_MEMBER_WITHOUT;
			case true:
				return MembershipSelectionType.MEMBER_BASIS;
			default:
				return MembershipSelectionType.NO_MEMBER_WITHOUT;
		}
	}
	/**
	 * getMembershipApplication value as used in backend API
	 */
	export function getMembershipApplication(type: string): boolean {
		switch (type) {
			case MembershipSelectionType.NO_MEMBER_WITHOUT:
			case MembershipSelectionType.UNKNOWN:
			case MembershipSelectionType.MEMBER_BASIS:
			case MembershipSelectionType.MEMBER_PLUS:
				return false;
			case MembershipSelectionType.NO_MEMBER_BASIS:
			case MembershipSelectionType.NO_MEMBER_PLUS:
				return true;
			default:
				return false;
		}
	}
}

/**
 * Represents the Default membership selection.
 */
export enum DefaultMembershipSelectionEnum {
	UNKNOWN = 0,  // default selection is unknown
	NO_SELECTION = 1,  // no default selection
	NO_MEMBER_BASIS_SELECTION = 2 // default selection is get a basis member
}